import React from "react";
import { DeleteOutlined, DiffOutlined, FileAddOutlined } from "@ant-design/icons";
import DiffViewer, { DiffFormat, isEmptySide } from "@src/ui/DiffViewer"

/**
 * What a change instance's declaration section shows, to title it: a diff
 * when there are two versions to compare, or the one declaration there is —
 * a creation (nothing before it) or a deletion (nothing after it). Named,
 * not in a tense: the change may be pending, or long done. Read from the
 * declarations themselves, as DiffViewer reads them, not from the change
 * type: a CREATE that replaces an unfinished one has a version before it.
 */
export const declarationHeading = (change_instance: any) => {
    const before = !isEmptySide(change_instance?.old_declaration?.declaration);
    const after = !isEmptySide(change_instance?.new_declaration?.declaration);
    if (after && !before) return { title: 'Declaration creation', Icon: FileAddOutlined };
    if (before && !after) return { title: 'Declaration deletion', Icon: DeleteOutlined };
    return { title: 'Declaration diff', Icon: DiffOutlined };
};

/**
 * A change instance's declaration against the one before it — the data
 * itself, written out by DiffViewer as YAML or JSON (`format`, YAML by
 * default), with the switch between the two in its title row unless
 * `enableYaml` is turned off.
 */
const DeclarationDiff = ({
    change_instance,
    format = 'yaml',
    enableYaml = true,
}: {
    change_instance: any;
    format?: DiffFormat;
    enableYaml?: boolean;
}) => (
    <DiffViewer
        leftTitle={change_instance?.old_declaration ? `Version ${change_instance?.old_declaration?.version}` : "Previous Declaration"}
        rightTitle={change_instance?.new_declaration ? `Version ${change_instance?.new_declaration?.version}` : 'Removed'}
        oldValue={change_instance?.old_declaration?.declaration}
        newValue={change_instance?.new_declaration?.declaration}
        format={format}
        enableYaml={enableYaml}
        splitView={true}
    />
);

export default DeclarationDiff;
